var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_2284)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_80_2284)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_80_2284)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_80_2284",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 51
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0.219727H0V50.2197H50V0.219727Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_80_2284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.994 43.7094C26.9352 44.6713 25.7586 45.6995 25.0022 45.9307C24.1089 45.6628 22.6513 44.3094 20.5192 42.3299C20.1572 41.9937 19.7727 41.6368 19.3635 41.2594C11.4412 33.9529 2.94141 23.2616 2.84472 15.1668C2.81159 12.3975 3.73825 10.1393 5.67746 8.26313C8.1995 5.82327 11.4901 4.47956 14.9434 4.47956C18.3358 4.47956 21.5619 5.76184 24.028 8.09022C24.5758 8.60752 25.4322 8.60752 25.9802 8.09022C28.4467 5.76184 31.6733 4.47956 35.0657 4.47956C38.5188 4.47956 41.8095 5.82327 44.3316 8.26299C48.3239 12.1256 48.1021 17.9624 43.6725 25.6113C43.2789 26.2908 43.5109 27.1608 44.1905 27.5543C44.8699 27.9481 45.74 27.7162 46.1336 27.0365C52.5716 15.9193 49.7825 9.57968 46.309 6.21913C43.2533 3.26354 39.2605 1.63574 35.0654 1.63574C31.3781 1.63574 27.8518 2.8829 25.004 5.17146C22.1566 2.88275 18.6305 1.63574 14.9432 1.63574C10.7483 1.63574 6.75541 3.26354 3.7 6.21927C1.20327 8.63496 -0.0411911 11.6566 0.0010397 15.2006C0.136406 26.5252 13.3797 39.6093 17.4354 43.3499C17.8422 43.7252 18.2243 44.0798 18.5842 44.4138C21.5564 47.1736 23.0484 48.5587 24.8187 48.7915C24.8801 48.7996 24.9421 48.8036 25.004 48.8036C25.0658 48.8036 25.1277 48.7996 25.1891 48.7915C26.6123 48.6046 27.8941 47.6421 29.9061 45.8143C30.4873 45.2862 30.5305 44.3869 30.0024 43.8057C29.4744 43.2245 28.5752 43.1815 27.994 43.7094Z",
    fill: "#003588"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1507 29.8779H40.584V25.3115C40.584 24.5264 39.9474 23.8896 39.1621 23.8896H33.4438C32.6585 23.8896 32.0219 24.5264 32.0219 25.3115V29.8779H27.4552C26.6698 29.8779 26.0332 30.5146 26.0332 31.2998V37.0186C26.0332 37.8038 26.6698 38.4405 27.4552 38.4405H32.0219V43.0068C32.0219 43.792 32.6585 44.4287 33.4438 44.4287H39.1621C39.9474 44.4287 40.584 43.792 40.584 43.0068V38.4405H45.1507C45.936 38.4405 46.5726 37.8038 46.5726 37.0186V31.2998C46.5726 30.5145 45.936 29.8779 45.1507 29.8779ZM43.7288 35.5967H39.1621C38.3767 35.5967 37.7401 36.2334 37.7401 37.0186V41.5849H34.8657V37.0186C34.8657 36.2334 34.2292 35.5967 33.4438 35.5967H28.8771V32.7217H33.4438C34.2292 32.7217 34.8657 32.085 34.8657 31.2998V26.7334H37.7401V31.2998C37.7401 32.085 38.3767 32.7217 39.1621 32.7217H43.7288V35.5967Z",
    fill: "#003588"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_2284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0 0.219727)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_80_2284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0 0.219727)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_80_2284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0 0.219727)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanion);
export default __webpack_public_path__ + "static/media/companion.0c238f8fbb3b9d07b42fc4b4ca828a9e.svg";
export { ForwardRef as ReactComponent };